<template>
    <div>
        <SeleccionarRegion
            v-if="paso1"
            :key="key_seleccionar_region"
            :abonado="abonado"
            :recuperarSoloZonaAnexas="recuperarSoloZonaAnexas"
            :disabled="disabled"
            @zonaSeleccionada="zonaSeleccionada"
            @bloquearAsientos="bloquearRenovacionSinAsientos"
            @continuarSinPlazaParking="continuarSinPlazaParking"
        />
    
        <transition name="fade" mode="out-in">
            <SeleccionarAsientosRegionNormal
                v-if="paso2 && ! zona.tiene_plazas"
                :asientos="asientos"
                :datos_compradores="datos_compradores"
                :zona="zona"
                @volver="volver"
                @asientosSeleccionados="asientosSeleccionados"
                :disabled="bloqueando || disabled"
            />

            <SeleccionarAsientosRegionAnexa 
                v-if="paso2 && zona.tiene_plazas"
                :zona="zona"
                :abonado="abonado"
                :recuperarSoloZonaAnexas="recuperarSoloZonaAnexas"
                :disabled="bloqueando || disabled"
                @asientosSeleccionados="asientosSeleccionados"
                @continuarSinPlazaParking="continuarSinPlazaParking"
                @volver="volver"
            />
        </transition>
    </div>
</template>

<script>

    import SeleccionarRegion from './SeleccionarAsientosConRegiones/SeleccionarRegion.vue';
    import SeleccionarAsientosRegionNormal from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionNormal.vue";
    import SeleccionarAsientosRegionAnexa from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionAnexa.vue";

    export default {
        props: {
            disabled: {
                required: true,
                type: Boolean
            },
            changeSeat: {
                required: true,
                type: Number
            },
            abonado: {
                required: false,
                type: Object
            },
            recuperarSoloZonaAnexas: {
                default: false,
                type: Boolean
            },
            bloquear: {
                required: false,
                type: Function,
                default: null
            }
        },
        data() {
            return {
                paso1: true,
                paso2: false,
                zona: null,
                asientos: [],
                datos_compradores: [],
                key_seleccionar_region: 1,
                bloqueando: false,
                zonas_anexas: []
            }
        },
        methods: {
            asientosSeleccionados(datos_compradores_temp, asientos_temp) {
                this.datos_compradores = datos_compradores_temp;
                this.asientos = asientos_temp;
                this.bloquearAsientos();
            },
            bloquearAsientos() {
                this.bloqueando = true;

                var seats = [];

                this.asientos.forEach(abonado => {
                    if(abonado.asiento) {
                        let payload = {
                            seat: abonado.asiento.asiento,
                            row: abonado.asiento.fila,
                            zona_id: abonado.asiento.zona_id,
                        };

                        if(this.renovacion && this.abonado?.id) {
                            payload.abonado_id = this.abonado.id;
                        }

                        seats.push(payload);
                    }                
                });

                var plazas = [];

                this.asientos.forEach(asiento => {
                    if(asiento.plaza) {
                        plazas.push({
                            id: asiento.plaza.id,
                            region_id: this.zona.id,
                            abonado_id: this.abonado ? this.abonado.id : null
                        });
                    }
                });

                let params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    tid: this.configuracion.hash_teatro,
                    butacas: plazas
                };

                if (this.recuperarSoloZonaAnexas) {
                    params.filters.session_id = sessionStorage.getItem("session_id");
                } else {
                    params.zona_id = this.zona_id;
                    params.asientos = seats;
                }

                const url = this.recuperarSoloZonaAnexas ? 'front.bloquear.abonos-parking' : 'front.bloquear.asientos';

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                const fbp = this.$cookies.get("_fbp");
                const fbc = this.$cookies.get("_fbc");

                if (fbp && fbc){
                    params.fbp = fbp;
                    params.fbc = fbc;
                }

                // When a :bloquear prop is provided AND the call targets
                // bloquear-asientos (the seat-blocking path that supports
                // identificacion_*), delegate to it. Otherwise fall back to
                // the legacy raw Vuex dispatch (used for parking + scope-out
                // paths to keep this PR surgical).
                const useProp = typeof this.bloquear === 'function' && url === 'front.bloquear.asientos';

                const dispatchPromise = useProp
                    ? Promise.resolve().then(() => this.bloquear(params))
                    : Promise.resolve(this.$store.dispatch(this.config.getVuexAlias(url), params));

                dispatchPromise.then(res => {
                    if(res.data.error) {
                        this.volver();
                        this.$toast.error('Butaca/s ocupada/s');
                    } else {
                        this.$emit('butacasBloqueadas', this.datos_compradores, this.asientos, this.zona, res.data.session_id, this.zonas_anexas)
                        sessionStorage.setItem('session_id', res.data.session_id);
                        this.$emit("sessionButacaData", res.data);

                    }

                }).catch(error => {
                    if (error && error.message === 'IDENTIFICACION_INVALIDA') {
                        // Host already resets seats + routes back; do not show toast.
                        this.$emit('identificacion-invalida');
                    } else {
                        this.volver();
                        this.$toast.error('Butaca/s elegida/s por otro usuario.');
                    }
                }).finally(() => {
                    this.bloqueando = false;
                });
            },
            bloquearRenovacionSinAsientos(datos_compradores, asientos, zona) {
                this.datos_compradores = datos_compradores;
                this.asientos = asientos;
                this.zona = zona;
                this.bloquearAsientos();
            },
            zonaSeleccionada(zona, anexas = null) {
                this.zona = zona;
                if (anexas && anexas.length) {
                    this.zonas_anexas = anexas;
                }
                this.paso1 = false;
                this.paso2 = true;
            },
            volver() {
                if (this.renovacion && !this.recuperarSoloZonaAnexas) {
                    this.$router.push({ name: 'front.abonos.nuevo.index', query: { region_id: this.zona.id, dni: this.abonado.dni, n_abonado_antiguo: this.abonado.n_abonado_antiguo } });
                }

                this.key_seleccionar_region++;
                this.asientos = [];
                this.datos_compradores = [];
                this.paso2 = false;
                this.paso1 = true;
            },
            continuarSinPlazaParking() {
                this.$emit('continuarSinPlazaParking');
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            renovacion() {
                return this.$route.query.n_abonado_antiguo != null;
            }
        },
        watch: {
            changeSeat() {
                this.asientos = [];
                this.datos_compradores = [];
                this.reloadComponent += 1;
                this.key_seleccionar_region++;
            }
        },
        components: {
            SeleccionarAsientosRegionNormal, SeleccionarRegion, SeleccionarAsientosRegionAnexa
        }
    }
</script>